const randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
export default {
  randomUUID
};


//////////////////
// WEBPACK FOOTER
// ./~/uuid/dist/esm-browser/native.js
// module id = 2305
// module chunks = 2